import alkemy from '../img/alkemy.webp'
import alkemy_logo from '../img/alkemy_logo.jpg'
import angular from '../img/angular.png'
import apmin from '../img/apmin.webp'
import bootstrap from '../img/bootstrap.png'
import boxcustodia_logo from '../img/boxcustodia.jpg'
import coder from '../img/coder.svg'
import css from '../img/css.png'
import done from '../img/done.webp'
import ecommerce from '../img/ecommerce.webp'
import express from '../img/express.png'
import figma from '../img/figma.png'
import firebase from '../img/firebase.png'
import flecha from '../img/flecha.png'
import github from '../img/github.png'
import gmail from '../img/gmail.png'
import hiro from '../img/hiro.webp'
import html from '../img/html.png'
import illustrator from '../img/illustrator.png'
import javascript from '../img/javascript.png'
import jn from '../img/jn.png'
import librery from '../img/librery.webp'
import linkedin from '../img/linkedin.png'
import logoentero from '../img/logoentero.png'
import mongo from '../img/mongo.png'
import myportfolio from '../img/myportfolio.webp'
import mysql from '../img/mysql.png'
import next from '../img/next.png'
import node from '../img/node.png'
import perfil from '../img/perfil.png'
import photoshop from '../img/photoshop.png'
import php from '../img/php.png'
import react from '../img/react.png'
import redux from '../img/redux.png'
import sass from '../img/sass.png'
import tailwind from '../img/tailwind.png'
import techfix from '../img/techfix.webp'
import trady from '../img/trady.webp'
import trama from '../img/trama.png'
import vink from '../img/vink.webp'
import wordpress from '../img/wordpress.png'

const images = {
  alkemy_logo,
  boxcustodia_logo,
  trady,
  myportfolio,
  techfix,
  hiro,
  librery,
  apmin,
  vink,
  alkemy,
  ecommerce,
  done,
  bootstrap,
  coder,
  css,
  express,
  flecha,
  figma,
  firebase,
  gmail,
  github,
  javascript,
  jn,
  html,
  illustrator,
  angular,
  linkedin,
  logoentero,
  mongo,
  mysql,
  node,
  next,
  perfil,
  photoshop,
  php,
  react,
  redux,
  sass,
  trama,
  tailwind,
  wordpress,
}
export default images
